import React, { useState, useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Route, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';
import { Tooltip } from 'primereact/tooltip';
import PrimeReact from 'primereact/api';


import { AppTopbar } from '../../AppTopbar';
import { AppFooter } from '../../AppFooter';
import { AppMenu } from '../../AppMenu';
import { AppConfig } from '../../AppConfig';

import Dashboard from '../../components/Dashboard';
import ButtonDemo from '../../components/ButtonDemo';
import ChartDemo from '../../components/ChartDemo';
import Documentation from '../../components/Documentation';
import FileDemo from '../../components/FileDemo';
import FloatLabelDemo from '../../components/FloatLabelDemo';
import FormLayoutDemo from '../../components/FormLayoutDemo';
import InputDemo from '../../components/InputDemo';
import ListDemo from '../../components/ListDemo';
import MenuDemo from '../../components/MenuDemo';
import MessagesDemo from '../../components/MessagesDemo';
import MiscDemo from '../../components/MiscDemo';
import OverlayDemo from '../../components/OverlayDemo';
import MediaDemo from '../../components/MediaDemo';
import PanelDemo from '../../components/PanelDemo';
import TableDemo from '../../components/TableDemo';
import TreeDemo from '../../components/TreeDemo';
import InvalidStateDemo from '../../components/InvalidStateDemo';
import BlocksDemo from '../../components/BlocksDemo';
import IconsDemo from '../../components/IconsDemo';
import  {ConsultaRecibos} from './consulta/ConsultaRecibos';
import {TimbrarExcel} from './archivo/TimbrarExcel';
import { ServicioHttp } from '../../servicios/ServicioHttp';
import { Emisor } from './emisor/Emisor';
import {Cancelacion} from './cancelacion/Cancelacion';
import {Reportes} from './reportes/Reportes';
import {ConsultaUsuario} from './usuario/ConsultaUsuario';
import {Prueba, Pueba} from './pruebas/Prueba';

export const Bienvenido = () => {
    const [layoutColorMode, setLayoutColorMode] = useState('light')
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [staticMenuInactive, setStaticMenuInactive] = useState(false);
    const [menu,setMenu]=useState([]);
    const [layoutMode, setLayoutMode] = useState('static');
    const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);
    const [inputStyle, setInputStyle] = useState('outlined');
    const [ripple, setRipple] = useState(true);
    const copyTooltipRef = useRef();
    const location = useLocation();

    let menuClick = false;
    let mobileTopbarMenuClick = false;

    useEffect(() => {   
        crearMenu();     
        if (mobileMenuActive) {
            addClass(document.body, "body-overflow-hidden");
        } else {
            removeClass(document.body, "body-overflow-hidden");
        }
    }, [mobileMenuActive,location]);

    const onRipple = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value)
    }

    const addClass = (element, className) => {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    const removeClass = (element, className) => {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    const onToggleMenuClick = (event) => {
        menuClick = true;

        if (isDesktop()) {
            if (layoutMode === 'overlay') {
                if (mobileMenuActive === true) {
                    setOverlayMenuActive(true);
                }

                setOverlayMenuActive((prevState) => !prevState);
                setMobileMenuActive(false);
            }
            else if (layoutMode === 'static') {
                setStaticMenuInactive((prevState) => !prevState);
            }
        }
        else {
            setMobileMenuActive((prevState) => !prevState);
        }

        event.preventDefault();
    }

    const isDesktop = () => {
        return window.innerWidth >= 992;
    }

    const onMobileTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        setMobileTopbarMenuActive((prevState) => !prevState);
        event.preventDefault();
    }

    const onMobileSubTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        event.preventDefault();
    }

    const onColorModeChange = (mode) => {
        setLayoutColorMode(mode)
    }

    const onSidebarClick = () => {
        menuClick = true;
    }

    const onInputStyleChange = (inputStyle) => {
        setInputStyle(inputStyle);
    }

    

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }
    }

    const wrapperClass = classNames('layout-wrapper', {
        'layout-overlay': layoutMode === 'overlay',
        'layout-static': layoutMode === 'static',
        'layout-static-sidebar-inactive': staticMenuInactive && layoutMode === 'static',
        'layout-overlay-sidebar-active': overlayMenuActive && layoutMode === 'overlay',
        'layout-mobile-sidebar-active': mobileMenuActive,
        'p-input-filled': inputStyle === 'filled',
        'p-ripple-disabled': ripple === false,
        'layout-theme-light': layoutColorMode === 'light'
    });

    const onWrapperClick = (event) => {
        if (!menuClick) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }

        if (!mobileTopbarMenuClick) {
            setMobileTopbarMenuActive(false);
        }

        mobileTopbarMenuClick = false;
        menuClick = false;
    }

    const onLayoutModeChange = (mode) => {
        setLayoutMode(mode)
    }
    const crearMenu=()=>{
        ServicioHttp.consumirPostHttp("accion/buscar_acciones.json").then(response=>{
            setMenu(response.data.lista);
        });
    }


    return (
        <div className={wrapperClass} onClick={onWrapperClick}>
            <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />
            <AppTopbar onToggleMenuClick={onToggleMenuClick} layoutColorMode={layoutColorMode}
                mobileTopbarMenuActive={mobileTopbarMenuActive} onMobileTopbarMenuClick={onMobileTopbarMenuClick} onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick} />

            <div className="layout-sidebar" onClick={onSidebarClick}>
                <AppMenu model={menu} onMenuItemClick={onMenuItemClick} layoutColorMode={layoutColorMode} />
            </div>

            <div className="layout-main-container">
                <div className="layout-main"> 
                    <Route path="/" exact render={() => <Dashboard colorMode={layoutColorMode} location={location} />} />
                    <Route path="/Nomifast/bienvenido/consultarecibos" component={ConsultaRecibos} />
                    <Route path="/Nomifast/bienvenido/subirlayout" component={TimbrarExcel} />
                    <Route path="/Nomifast/bienvenido/emisor" component={Emisor} />
                    <Route path="/Nomifast/bienvenido/cancelacion" component={Cancelacion} />
                    <Route path="/Nomifast/bienvenido/reporte" component={Reportes} />
                    <Route path="/Nomifast/bienvenido/usuarios" component={ConsultaUsuario} />
                    <Route path="/Nomifast/bienvenido/prueba" component={Prueba} />
                </div>
                <AppFooter layoutColorMode={layoutColorMode} />
                </div>

            

           

           


            <CSSTransition classNames="layout-mask" timeout={{ enter: 200, exit: 200 }} in={mobileMenuActive} unmountOnExit>
                <div className="layout-mask p-component-overlay"></div>
            </CSSTransition>

        </div>
    );
}